class ProductAdditions extends HTMLElement {
  constructor() {
    super();

    this.FIELDSET_HIDDEN_CLASS = "fieldset--hidden";
    this.HIDDEN_CLASS = "product__additions--hidden";
  }

  connectedCallback() {
    this.additions.forEach(addition => addition.addEventListener("change", () => this.publishPriceChangeEvent()));

    if (this.secondAddition) this.firstAddition.addEventListener("change", this.onAdditionChange.bind(this));

    subscribe(PUB_SUB_EVENTS.hideAdditions, () => this.hideAdditions());
  }

  /**
   * Handle the addition change event
   * @param {Event} event
   */
  onAdditionChange(event) {
    const shouldShow = event.target.checked && event.target.value !== "";
    const action = shouldShow ? 'remove' : 'add';

    this.secondAddition.classList[action](this.FIELDSET_HIDDEN_CLASS);
  }

  hideAdditions() {
    this.classList.add(this.HIDDEN_CLASS);
  }

  publishPriceChangeEvent() {
    let price = 0;

    this.additions.forEach(addition => {
      if (addition.checked && addition.value !== "") {
        const priceAttribute = addition.getAttribute("data-addition-price");

        if (priceAttribute) price += parseFloat(priceAttribute);
      }
    });

    publish(PUB_SUB_EVENTS.productPriceChange, price);
  }

  get additions() {
    return this.querySelectorAll("[data-addition]");
  }

  /**
   * Get the first addition fieldset element
   * @returns {Element}
   */
  get firstAddition() {
    return this.querySelector("[data-addition-fieldset-one]");
  }

  /**
   * Get the second addition fieldset element
   * @returns {Element}
   */
  get secondAddition() {
    return this.querySelector("[data-addition-fieldset-two]");
  }
}

customElements.define('product-additions', ProductAdditions);